import { useTranslation } from 'react-i18next';

import { AccessoryTabProps } from 'components/desktop/Accessory/AccessoryComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import CharacteristicRadioSelect from 'components/desktop/_general/CharacteristicSelect/CharacteristicRadioSelect';
import { Characteristic } from 'enums/characteristic';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const AccessoryCharacteristicsCard = ({
	state,
	handlers,
}: AccessoryTabProps): JSX.Element => {
	const { t } = useTranslation();
	const isAccessoryEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEACCESSORY,
	]);

	const handleCharacteristicChange = async (checked: boolean, elementId: string) => {
		switch (elementId) {
			case Characteristic.Fluid:
				if (checked) {
					handlers.setCharacteristic(Characteristic.Fluid);
				}
				break;
			case Characteristic.SolidNonQuantifiable:
				if (checked) {
					handlers.setCharacteristic(Characteristic.SolidNonQuantifiable);
				}
				break;
			case Characteristic.SolidQuantifiable:
				if (checked) {
					handlers.setCharacteristic(Characteristic.SolidQuantifiable);
				}
				break;
		}
	};

	return (
		<FoldableCard
			dataComponentType="accessory-characteristics-card"
			defaultOpen={true}
			title={t('_general:CHARACTERISTICS')}
			content={
				<div className="card-body">
					<CharacteristicRadioSelect
						checked={state.characteristic}
						disabled={!isAccessoryEditor}
						handleCharacteristicChange={handleCharacteristicChange}
					/>
				</div>
			}
		/>
	);
};
